import mitt from 'mitt';

export type MessageType = 'exception' | 'error' | 'warning' | 'info' | 'success';

export interface Flash extends FlashMessage {
  type: MessageType;
}

export interface FlashMessage {
  title: string;
  description: string | null;
  details?: string[];
}

type FlashEvents = {
  info: FlashMessage;
  success: FlashMessage;
  warning: FlashMessage;
  error: FlashMessage;
  exception: FlashMessage;
  clear: undefined;
};

const emitter = mitt<FlashEvents>();

export const flash = emitter.emit;
export const onFlash = emitter.on;
